<ca-modal-container
    modalTitle="Edit Profile Image"
    description="Here you can provide and edit your profile image. Please upload a jpg or png file."
    (dismiss)="dismiss('Canceled')"
>
    <form *ngIf="formGroup && formGroup.get('picture') != null" [formGroup]="formGroup" (ngSubmit)="submitProfile()" novalidate>
        <div class="wrap">
            <ca-file-upload
                [blobType]="portraitBlobType"
                [allowMultipleFiles]="false"
                [uploaderKey]="'edit_portrait_upload'"
                [maxInputSizeInBytes]="1024 * 1024"
                [supportedFileTypes]="supportedImageTypes"
                (onUploadCompleted)="onUploadCompleted($event)"
                (invalidFiles)="setPictureError($event)"
            ></ca-file-upload>
            <small *ngIf="formGroup.get('picture')?.hasError('maxFileSize')" class="invalid-feedback">
                {{ (formGroup.get('picture')?.errors)['maxFileSize'] }}
            </small>
            <small *ngIf="formGroup.get('picture')?.hasError('invalidImageType')" class="invalid-feedback">
                {{ (formGroup.get('picture')?.errors)['invalidImageType'] }}
            </small>
            <div class="exist-item" data-uit="portrait-editor-profile-image" *ngIf="formGroup.get('picture')?.value">
                <span class="file-name" data-uit="portrait-editor-profile-image-name">{{ formGroup.get('picture')?.value }}</span>
                <button type="button" class="btn ca-btn-icon ca-btn-icon-small" (click)="removeFileItem()" data-uit="remove-profile-image-button">
                    <ca-icon name="cross" size="s"></ca-icon>
                </button>
            </div>
            <input class="form-control picture" title="Picture" formControlName="picture" hidden />
        </div>
        <div class="button-area text-end">
            <button type="submit" class="btn btn-primary mt-3" caAutoFocus [disabled]="isSubmitting || !formGroup.valid" data-uit="save-and-close-image-modal">
                {{ 'GENERAL.SAVE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
